import * as React from "react";
import get from "lodash/get";
import "./Checkbox.css";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";

export interface CheckboxProps extends ComponentBaseProps {
  checked: boolean;
  checkboxScale?: number;
  label?: string;
  labelStyle?: React.CSSProperties;
  onChange: (checked: boolean) => void;
  style?: React.CSSProperties;
}

export class Checkbox extends ComponentBase<CheckboxProps> {
  handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.onChange(event.target.checked);
  };

  render() {
    const {
      style,
      label,
      labelStyle,
      checkboxScale,
      configName,
      checked,
      isEditing,
    } = this.props;

    return (
      <div
        className={`Checkbox-container ${
          !isEditing ? "Checkbox-container-preview" : ""
        }`}
        style={style}
        onDragStart={this.onDragStart}
        ref={(component) => (this.component = component)}
      >
        <label htmlFor={configName} className="Checkbox-label">
          <span className="Checkbox-input-container">
            <input
              style={{ transform: `scale(${checkboxScale || 1})` }}
              className="Checkbox-input"
              type="checkbox"
              checked={checked}
              onChange={this.handleOnChange}
              id={configName}
              aria-label={get(this.props, "label", "")}
              tabIndex={0}
            />
            <span className="Checkbox-styled-input">
              <span className="Checkbox-glyph">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path
                    fill="currentColor"
                    d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                  />
                </svg>
              </span>
            </span>
          </span>
          <span style={labelStyle}>{label}</span>
        </label>
      </div>
    );
  }
}
